import { Api } from "../config/request";

const getGameDetails = async (data) =>{
    let response= await Api.PostRequest("/getActiveGameDetails", data);
    return response.data;
}
const updateGameScore = async (data) =>{
    let response= await Api.PostRequest("/updateGameTeamScores", data);
    return response.data;
}

const submitDetails = async (data) =>{
    let response = await Api.PostRequest("/recordLiveGameActionInLiveGameActivity", data);
    return response.data;
}

const timerEdit = async (data) =>{
    let response = await Api.PostRequest("/updateGameTimer", data);
    return response.data;
}


const getActiveGameActions = async (data) =>{
    let response = await Api.PostRequest("/getActiveSportActionsForUniversityIdAndSportId", data);
    return response.data;
}

const updateGameSessionByGameId = async (data) =>{
    let response = await Api.PostRequest("/updateGameSessionByGameId", data);
    return response.data;
}

const getAllLiveGameActionsByGameId = async (data) =>{
    let response = await Api.PostRequest("/getAllLiveGameActionsByGameId", data);
    return response.data;
}

const awardPointsForAction = async (data) =>{
    let response = await Api.PostRequest("/awardPointsForAction", data);
    return response.data;
}

const addGenericCommentary = async (data) =>{
    let response = await Api.PostRequest("/addGenericCommentary", data);
    return response.data;
}

const updateCurrentlyPlayingPlayers = async (data) =>{
    let response = await Api.PostRequest("/updateCurrentlyPlayingPlayers", data);
    return response.data;
}

const scorerApi ={
    getGameDetails,
    updateGameScore,
    submitDetails,
    timerEdit,
    getActiveGameActions,
    updateGameSessionByGameId,
    getAllLiveGameActionsByGameId,
    awardPointsForAction,
    addGenericCommentary,
    updateCurrentlyPlayingPlayers
}

export default scorerApi;